import { LoginType, GlobalStore, key } from './types';

const localGetSuccess = (store: LoginType): boolean => store.success;
export const getLoginSuccess = (store: GlobalStore): boolean =>
	localGetSuccess(store[key]);

const localGetIsValid = (store: LoginType): boolean => store.valid;
export const getLoginIsValid = (store: GlobalStore): boolean =>
	localGetIsValid(store[key]);
